import { render, staticRenderFns } from "./departStatistic.vue?vue&type=template&id=c3b7b6d4&scoped=true"
import script from "./departStatistic.vue?vue&type=script&lang=js"
export * from "./departStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b7b6d4",
  null
  
)

export default component.exports